// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"707cbb5d","598":"df8a86df","703":"97f62614"}[chunkId] + ".chunk.js";
};